module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "glyphicon glyphicon-plus-sign"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84ba0ebc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlusIcon.vue
// module id = 461
// module chunks = 1